import { render } from "./photos-list.vue?vue&type=template&id=cd48cf20"
import script from "./photos-list.vue?vue&type=script&lang=js"
export * from "./photos-list.vue?vue&type=script&lang=js"

import "./photos-list.vue?vue&type=style&index=0&id=cd48cf20&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__